"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SearchInputButton = require("./SearchInputButton");
Object.keys(_SearchInputButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchInputButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SearchInputButton[key];
    }
  });
});
